export enum Analytics {
  TapAndroidApp = 'TapAndroidApp',
  TapIOSApp = 'TapIOSApp',
}

type AnalyticsGuestEvent =
  {
    name:
      typeof Analytics.TapAndroidApp |
      typeof Analytics.TapIOSApp,
    params: { label: string },
  }

export function trackEvent(event: AnalyticsGuestEvent) {
  if (process.env.NODE_ENV === 'production') {
    reachGoal(event.name, event.params);
  }
}

function reachGoal(target: string, params?: any): void {
  // @ts-ignore
  window.ym(105481035, 'reachGoal', target, params);
}
